import axios from "axios";
import { toast } from "react-toastify";
export const editLeague = async (api, data, token) => {
  const formData = new FormData();

  formData.append("title", data.title);
  formData.append("description", data.description);
  formData.append("club", data.club);
  formData.append("category", data.category);
  formData.append("sub_category", data.subCategory);
  formData.append("from_uk", data.from_uk);
  if (data?.video && Array.isArray(data.video)) {
    data.video.forEach((video) => {
      if (typeof video == "object") {
        formData.append("videoFile", video);
      }
    });
  }
  formData.append("region", data.region);
  formData.append("user_id", data.user_id);
  formData.append("visibility", data.visibility);
  if (data?.image && typeof data.image == "object") {
    formData.append("league_logo", data.image);
  } else {
  }

  if (data?.invite_users) {
    data.invite_users
      .filter((user) => user.phone_number)
      .map((user) => {
        formData.append("invite_users[]", user.phone_number);
      });
  }

  if (api == "/leagues/editLeague") {
    formData.append("league_id", data.league_id);
    if (data?.delete_videos.length > 0) {
      data.delete_videos.map((id) => {
        formData.append("delete_videos[]", id);
      });
    }
    if (data?.removedUsers?.length > 0) {
      data.removedUsers?.map((mem) => {
        formData.append("remove_users[]", mem.id);
      });
    }
  }

  // formData.append("video_meta", JSON.stringify(data.video_meta));
  // formData.append("editedVideo", JSON.stringify(data.editedVideoMeta));

  formData.append("video_meta", JSON.stringify(data.video_meta));
  formData.append("editedVideo", JSON.stringify(data.editedVideoMeta));

  data.video_meta.map((obj) => {
    if (obj.club_img?.file instanceof File) {
      formData.append("goalClubImgs", obj.club_img.file);
    }
  });

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL_USER}${api}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
